const USED_CORE_MMY_START_YEAR = 2022;

export function isUsedCoreMmyYear(year) {
  return parseInt(year, 10) >= USED_CORE_MMY_START_YEAR;
}
